import styled from "styled-components";
import { space, layout, flexbox, background, position, compose } from "styled-system";
import { Row as RSRow, Container as RSContainer, Col as RSCol } from "reactstrap";
export var Container = styled(RSContainer)(compose(space, layout, flexbox, background, position));
export var Row = styled(RSRow)(compose(space, layout, flexbox, background, position));
export var Col = styled(RSCol)(compose(space, layout, flexbox, background, position));
export var Box = styled.div(compose(space, layout, flexbox, background, position));